
const state = {
    lang: localStorage.getItem('lang') || 'CHS',
    show_mask: false,
    fixed_bar: false,
    simulation_bar: false,
    garbage_qrcode: false,
    activeqid: null,
    ajaxing_number: 0,
    construct_show: false,
    confirm_toast_show: false,
    searched_faq_list: [],
    searched_knowledge_list: [],
    routes: [],
    newDaily: true,
    loadingPosition: 'middle',
    bottom_bar: '',
    sourceList: null,
    authentical: false
}


const getters = {
    getSourceList: (state) => {
        return state.sourceList
    },
    bottomBar:(state)=>{
        return state.bottom_bar
    },
    getRoute: () => {
        return state.routes
    },
    lang: (state) => {
        return state.lang
    },
    _ShowMask: (state) => {
        return state.show_mask
    },
    _ShowFixedBar: (state) => {
        return state.fixed_bar
    },
    _ShowSimulation: (state) => {
        return state.simulation_bar
    },
    _ShowGarbageQrcode: (state) => {
        return state.garbage_qrcode
    },
    _ActiveQId: (state) => {
        return state.activeqid
    },
    _LOADING: (state) => {
        return !!state.ajaxing_number == 0
    },
    _CONSTRUCT: (state) => {
        return state.construct_show
    },
    _CONFIRM: (state) => {
        return state.confirm_toast_show
    },
    _FAQLIST: (state) => {
        return state.searched_faq_list
    },
    _KNOELEDGELIST: (state) => {
        return state.searched_knowledge_list
    },
    newDaily: (state) => {
        return state.newDaily
    },
    _LoadingPosition: (state) => {
        return state.loadingPosition
    },
    _Auth: (state) => {
        return state.authentical
    }
}


const actions = {}

const mutations = {
    setSourceList (state, param) {
        state.sourceList = param
    },
    setBottomBar (state, param) {
        state.bottom_bar = param
    },
    setRoute (state, param) {
        state.routes.push(param)
    },
    LANG (state, param) {
        state.lang = param
    },
    MASK (state, payload) {
        state.show_mask = payload
    },
    SET_AUTH (state) {
        state.authentical = true
    },
    RENDER_FIXED_BAR (state, param) {
        state.fixed_bar = param
    },
    SIMULATION_BAR (state, param) {
        state.simulation_bar = param
    },
    GARBAGE_QRCODE (state, param) {
        state.garbage_qrcode = param
    },
    ACTIVE_QID (state, param) {
        state.activeqid = param
    },
    AJAX_REQUEST (state) {
        state.ajaxing_number += 1
    },
    AJAX_REPONSE (state) {
        state.ajaxing_number -= 1
    },
    AJAX_RESET_COUNT (state) {
        state.ajaxing_number = 0
    },
    CONSTRUCT (state, param) {
        state.construct_show = param
    },
    BACK_CONFIRM (state, param) {
        state.confirm_toast_show = param
    },
    SET_FAQ_LIST (state, param) {
        state.searched_faq_list = param
    },
    SET_KNOWLEDGE_LIST (state, param) {
        state.searched_knowledge_list = param
    },
    CLEAR_FAQ_LIST (state) {
        state.searched_faq_list = []
    },
    CLEAR_KNOWLEDGE_LIST (state) {
        state.searched_knowledge_list = []
    },
    NEWDAILY (state,param) {
        state.newDaily = param;
    },
    SET_LOADING_POSITION (state,param) {
        state.loadingPosition = param;
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js